import { useRef } from "react";
import { SIGN_UP_URL } from "../lib/site";
import { HeroChart } from "./HeroChart";

/**
 * The hero is the chart. The headline sits in the top-left corner, where a "chance by date" curve never goes, and
 * the curve rises underneath it to the right.
 */
export function Hero() {
	const text = useRef<HTMLDivElement>(null);
	return (
		<section id="top" className="grid-paper relative -mt-16 overflow-hidden pt-16 lg:pb-12">
			{/* The grid fades out below the hero, so the page settles onto plain paper. */}
			<div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-paper" aria-hidden />
			<div className="relative mx-auto max-w-[1240px] px-5 md:px-8">
				<div className="relative lg:h-[clamp(640px,calc(100svh-64px),800px)]">
					<div className="pointer-events-none relative z-10 max-w-[600px] pt-12 sm:pt-16 lg:pt-20">
						<div ref={text}>
							<h1 className="text-[clamp(3.4rem,8.2vw,7rem)] leading-[0.92] font-semibold tracking-[-0.045em] text-ink">Put a date on it.</h1>
							<p className="mt-7 max-w-[30rem] text-lg text-eggplant">
								ModelCurve forecasts when things happen, what they depend on, and what they do to the numbers you care about. Claude builds the first model. You
								drag the curves until they say what you mean.
							</p>
							<div className="pointer-events-auto mt-8 flex flex-wrap items-center gap-3">
								<a href={SIGN_UP_URL} className="btn btn-primary">
									Start free
								</a>
								<a href="#claude" className="btn btn-secondary">
									Build one with Claude
								</a>
							</div>
							<p className="mt-4 text-sm text-quiet">The first model is free. So is being wrong in private.</p>
						</div>
					</div>
					<HeroChart behind={text} className="mt-12 pb-10 lg:absolute lg:inset-0 lg:mt-0 lg:pb-0" />
				</div>
			</div>
		</section>
	);
}
